import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RegionModel} from '../../models/region.model';

@Injectable({
  providedIn: 'root'
})
export class LeafletRegionsControlService {
  selectedRegion = new BehaviorSubject<RegionModel | null>(null);

  setSelectedRegion(region: RegionModel): void {
    this.selectedRegion.next(region);
  }

  clearSelectedRegion(): void {
    this.selectedRegion.next(null);
  }
}
